import React from 'react';
import type {ErrorScope} from '@sail/observability';
import {useReports} from '@sail/observability';
import type {PrimitiveRecord, ReportErrorTags} from '../utils/errorHandling';
import {useComponentLoadMetric} from './ComponentLoadMetric';

export const useReportError = () => {
  const {preventComponentLoadReport} = useComponentLoadMetric();
  const {error} = useReports();

  return React.useCallback(
    (err: Error, tags?: ReportErrorTags, extras?: PrimitiveRecord) => {
      // Sessions that have errors won't report load
      preventComponentLoadReport();

      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      error(err, {tags: tags as ErrorScope['tags'] | undefined, extras});
    },
    [error, preventComponentLoadReport],
  );
};
